import { Stack, Typography } from '@mui/material';
import Image, { type StaticImageData } from 'next/image';
import EmptyPageIcon from 'public/img/illustrations/person-with-connections.svg';

interface Props {
  archived?: boolean;
}

export function NoReferralsExist({ archived = false }: Props) {
  return (
    <Stack
      data-testid="NoReferralsExist"
      sx={{
        alignItems: 'center',
        gap: 4,
        justifyContent: 'center',
        pt: { xs: 0, md: 4.5 },
      }}
    >
      <Image width={211} alt="" src={EmptyPageIcon as StaticImageData} />

      <Typography component="span" variant="h3" sx={{ textAlign: 'center' }}>
        {archived ? 'No Archived Referrals Found' : 'No Referrals Found'}
      </Typography>
    </Stack>
  );
}
